/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import JiraBaseRedirect from '@jira/spa-apps__common/src/JiraBaseRedirectWrapper.tsx';

const JiraBaseRedirectWrapper = (): React.JSX.Element => <JiraBaseRedirect />;

export default JiraBaseRedirectWrapper;
